import { BankDataPageTranslations } from '@aboutyou/legacy-shared/src/pages/AccountArea/BankData/context/TranslationProvider'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { useMemo } from 'react'

export function useBankDataPageTranslations(): BankDataPageTranslations {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      pageTitle: {
        default: t('Bankdaten'),
        form: t('Bankdaten eingeben'),
      },
      successToastMessage: t('Bankdaten gespeichert'),
      errorToastMessage: t(
        'Fehler. Bankdaten konnten nicht gespeichert werden.',
      ),
    }),
    [t],
  )
}
